import { Component, Input, OnInit } from '@angular/core';
import { HictoricDataReponseDTO, OperationHistoricDocumentationDTO } from '@app/requests/model/requests-model';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';

@Component({
  selector: 'scf-historical',
  templateUrl: './historical.component.html',
  styleUrls: ['./historical.component.scss'],
})
export class HistoricalComponent implements OnInit {
  @Input() numOperation: string = '';
  dataHistoric: HictoricDataReponseDTO;
  displayedColumns: string[] = ['index', 'date', 'commentary'];
  loaded = false;

  constructor(private requestGeyDataApi: RequestsGetDataApi) {}

  ngOnInit(): void {
    let numOperation: OperationHistoricDocumentationDTO = { numOperation: this.numOperation };
    this.requestGeyDataApi.postHistoric(numOperation).subscribe((data) => {
      this.dataHistoric = data;
      this.loaded = true;
    });
  }
}
